module.exports = __webpack_public_path__ + "img/everything.5b5c141.svg";